export type BigIntToString<T> = {
  [P in keyof T]: T[P] extends bigint
    ? string
    : T[P] extends object
    ? BigIntToString<T[P]>
    : T[P]
}

export type StringToBigInt<T> = {
  [P in keyof T]: T[P] extends string
    ? T[P] extends `${bigint}`
      ? bigint
      : T[P]
    : T[P] extends object
    ? StringToBigInt<T[P]>
    : T[P]
}

export function serializeBigIntToString<T>(obj: T): BigIntToString<T> {
  const result: any = Array.isArray(obj) ? [] : {}

  for (const key in obj) {
    const value = obj[key]
    if (typeof value === "bigint") {
      result[key] = value.toString()
    } else if (value && typeof value === "object") {
      result[key] = serializeBigIntToString(value)
    } else {
      result[key] = value
    }
  }

  return result
}

export function deserializeStringToBigInt<T>(obj: BigIntToString<T>): T {
  const result: any = Array.isArray(obj) ? [] : {}

  for (const key in obj) {
    const value = obj[key]

    if (typeof value === "string" && /^\d+$/.test(value)) {
      result[key] = BigInt(value)
    } else if (value && typeof value === "object") {
      result[key] = deserializeStringToBigInt(value)
    } else {
      result[key] = value
    }
  }

  return result
}
